// extracted by mini-css-extract-plugin
export default {"main":"styles_main__A2JP6","button":"styles_button__IScsj"};